import { render, staticRenderFns } from "./WalletConnect.vue?vue&type=template&id=61e8fc6e&scoped=true&"
import script from "./WalletConnect.vue?vue&type=script&lang=js&"
export * from "./WalletConnect.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnect.vue?vue&type=style&index=0&id=61e8fc6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8fc6e",
  null
  
)

export default component.exports